<template>
  <div class="container">

    <!--
      version 2.2
     -->
    <!-- 头部 -->
    <div class="fl_list_head">
      <div class="fl_list_head_type">
        <div @click="FLSelectCity()" class="fl_list_head_type_city">{{city}}</div>
        <div @click="FLSelectRadiuo('1')" :class="[{'fl_list_head_type_typeS':radio=='1'},'fl_list_head_type_type']">
          翡瑜伽
          <label v-show="radio=='1'" class="fl_list_head_type_type_la"></label>
        </div>
        <div @click="FLSelectRadiuo('0')" :class="[{'fl_list_head_type_typeS':radio=='0'},'fl_list_head_type_type']">
          沸健身
          <label v-show="radio=='0'" class="fl_list_head_type_type_la"></label>
        </div>
        <div class="clearboth"></div>
      </div>
      <div v-show="radio=='0'" class="fl_list_head_date">
        <appointmentDate @FLDateChildEvent="FLSelectDate" :toListDate="reserves_date" :order_date_index='order_date_index'></appointmentDate>
        <!-- <div :class="[{'fl_list_head_date_blockE':reserves_date.length==8},'fl_list_head_date_block']">
          <div v-for="(date_item,date_index) in reserves_date" @click="FLSelectDate(date_item,date_index)" :class="[{'fl_list_head_date_itemS':date_index==order_date_index},'fl_list_head_date_item']">
            <div class="fl_list_head_date_item_title1">{{date_item.date_week}}</div>
            <div class="fl_list_head_date_item_title2">{{date_item.date_simple}}</div>
          </div>
        </div> -->
      </div>
    </div>
    <!-- 占位 -->
    <div :class="[{'fl_seat_yoga':radio=='1'},'fl_seat_fit']"></div>
    <!-- 列表 -->
    <appointmentList @FLDetail="FLDetail" @FLCreate="FLCreate" :radio='radio' :loaded='loaded' :fl_stadium_list='fl_stadium_list'></appointmentList>
    <!-- <div :class="[{'fl_list_body_yoga':radio=='1'},'fl_list_body']">
      <div v-show="fl_stadium_list.length>0&&loaded==true">
        <div v-for="(stadium_item,stadium_index) in fl_stadium_list" class="fl_list_body_item">
          <div class="fl_list_body_item_imgMM">
            <img @click="FLDetail(stadium_item,stadium_index)" :src="stadium_item.thumb" class="fl_list_body_item_img" />
          </div>
          <div class="fllpr_panel">
            <div class="fllpr_panel_txt">
              门市价
              <label v-show="radio=='0'" class="fllpr_panel_origin">¥{{((stadium_item.origin_price)/100).toFixed(0)}}</label>
              <label v-show="radio=='1'" class="fllpr_panel_origin">¥200</label>
              <label class="fllpr_panel_viper">会员价</label>
              <label v-show="radio=='0'" class="fllpr_panel_vipprice">¥{{(((stadium_item.origin_price)/100)/2).toFixed(0)}}</label>
              <label v-show="radio=='1'" class="fllpr_panel_vipprice">¥100</label>
            </div>
            <div class="fllpr_panel_distance">
              <label v-if="stadium_item.distance != -1">{{stadium_item.distance}}</label>
              {{stadium_item.district}}
            </div>
          </div>
          <button @click="FLDetail(stadium_item,stadium_index)" v-show="stadium_item.is_black_vip!=1 && radio=='1'" class="fllpr_quickcreate">快速预约</button>
          <button @click="FLCreate(stadium_item,stadium_index)" v-show="stadium_item.stock>0 && stadium_item.is_black_vip!=1 && radio=='0'" class="fllpr_quickcreate">快速预约</button>
          <button @click="FLDetail(stadium_item,stadium_index)" v-show="stadium_item.is_black_vip!=1 && stadium_item.stock==0&& radio=='0'" class="fllpr_quickcreaten">今日已满</button>
          <div @click="FLDetail(stadium_item,stadium_index)" v-show="stadium_item.is_black_vip==1" class="fllpr_black">斐燃黑金专享</div>
        </div>
      </div>
      <div v-show="fl_stadium_list.length==0&&loaded==true">
        <div class="stadium_noHotel">
          <img class="stadium_noHotel_img" src="../../assets/images/base/no_hotel.png" />
          <div class="stadium_noHotel_title">暂无酒店</div>
          <div class="stadium_noHotel_cont">因新冠病毒疫情和政策法规，该地区酒店健身、瑜伽服务将逐渐开放预约</div>
        </div>
      </div>
    </div> -->
    <!-- 城市列表面板 -->
    <appointmentCityPanel @FLSelectCity="FLSelectCity" @FLSelectCityItem="FLSelectCityItem" @FLSwipertop="FLSwipertop" :cityPanelStatus="cityPanelStatus" :city="city" :city_list="city_list"></appointmentCityPanel>
    <!-- <div :class="cityPanelStatus ? 'nhl_city active' : 'nhl_city'" >
      <div class="city_title">当前定位城市</div>
      <div class="city_currentSelect">
        <div @click="FLSelectCity()" class="item">{{city}}</div>
      </div>
      <div class="city_stitle">热门城市</div>
      <div class="city_item">
        <div @click="FLSelectCityItem(cityItem,cityIndex)" v-for="(cityItem,cityIndex) in city_list" :key="cityIndex" class="item">{{cityItem.name}}</div>
      </div>
      <v-touch v-on:swipeup="FLSwipertop">
        <div class="city_gif" @click="FLSelectCity()">
          <img src="../../assets/images/base/upArrowGray.gif" />
        </div>
      </v-touch>
    </div> -->

  </div>
</template>

<script>
  import {distance,distancenum,getStValStatus,sortArry} from '../../lib/utils.js'
  import appointmentDate from '../subgroup/appointmentDate.vue'
  import appointmentList from '../subgroup/appointmentList.vue'
  import appointmentCityPanel from '../subgroup/appointmentCityPanel.vue'
  export default {
    components:{
      'appointmentDate':appointmentDate,
      'appointmentList':appointmentList,
      'appointmentCityPanel':appointmentCityPanel,
    },
    data() {
      return {
        loaded:false,//是否加载完
        reserves_date:[],//可预约日期
        order_date_index:0,//默认选中日期索引
        city_list:[],//城市列表
        city:'',//当前所在城市
        cityPanelStatus:false,//城市面板开启关闭状态 false:关闭  true:开启
        radio:'0',//运动类型
        fl_stadium_list:[],//场馆列表
        mycardList:[],//我的会员卡
        fl_userinfo:null,
      }
    },
    created() {},
    mounted() {
      // 获取预约日期
      this.FLGetSevenDate()
    },
    activated() {
      sessionStorage.removeItem('fullpage')
      this.cityPanelStatus=false//城市面板默认状态下关闭状态
      // --- 2.2---
      // 加载预约类型
      if(sessionStorage.getItem('listRadio')){
        this.radio=sessionStorage.getItem('listRadio')
        sessionStorage.removeItem('listRadio')
        this.loaded=false
        this.fl_stadium_list=[]
        this.FLGetSevenDate()
      }
      // 每次进入，判断页面标题是否显示正确
      if(this.radio=='0'||this.radio==0){
        // 斐燃生活——畅享顶级酒店游泳/健身/瑜伽
        document.title = '沸健身——畅享五星级奢华酒店游泳/健身';
      }else{
        document.title = '翡瑜伽——畅享五星级奢华酒店瑜伽';
      }
      // 分享模块，每次进入此页面都执行，
      this.getJsAuth()
      // 获取用户会员卡数据
      this.FLGetUserCard()
      // 获取用户信息
      this.FLGetUserInfo()
    },
    computed: {},
    methods: {
      // 分享模块
      getJsAuth() {
        // getJsAuth
        let that = this;
        // that.shareApp()
        // return
        var param = {
          url: encodeURIComponent(window.location.href)//location.href.split('#')[0]//encodeURIComponent(window.location.href)
        }
        var qs = require('qs');
        let url = this.api.userApi.getJsAuth
        this.axios.post(url, qs.stringify(param), )
        .then((res) => {
          // // console.log(res)
          wx.config({
            debug: false,
            appId: res.data.appid, // 必填，公众号的唯一标识
            timestamp: res.data.timestamp, // 必填，生成签名的时间戳
            nonceStr: res.data.noncestr, // 必填，生成签名的随机串
            signature: res.data.signature,
            jsApiList: [
              'getLocation',
              'updateAppMessageShareData', //自定义“分享给朋友”及“分享到QQ”按钮的分享内容（1.4.0） 新接口
              'updateTimelineShareData', //自定义“分享到朋友圈”及“分享到QQ空间”按钮的分享内容（1.4.0） 老接口
              'onMenuShareTimeline', //分享到朋友圈 老接口
              'onMenuShareAppMessage', //分享给盆友 老接口
            ]
          });
          wx.ready(function() {
            that.shareApp()
          });
        }).catch((error) => {
          console.warn(error)
          that.$toast(error);
        })
      },
      shareApp(){
        let that = this;
        const u = navigator.userAgent;
        const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
        // const baseurl = encodeURI((window.location.href).split('.cn')[0])+'.cn'//"http://test.official.unionfit.cn"; //本地测试地址
        if (isiOS) {
          wx.updateAppMessageShareData({
            title: '斐燃生活', // 分享标题
            desc: '全国高端酒店会员制专享平台，提供健身、瑜伽等服务', //分享描述
            link: encodeURI((window.location.href).split('.cn')[0])+'.cn', // 分享链接
            imgUrl: 'https://unionfit-img.oss-cn-beijing.aliyuncs.com/fit_logo.jpg', // 分享图标
            success(res) {
              console.log('斐燃生活分享')
              // alert('wx.updateAppMessageShareData')
              console.log(res)
            },
            fail(){
              // alert('fail wx.updateAppMessageShareData')
            }
          });
          wx.updateTimelineShareData({
            title: '斐燃生活', // 分享标题
            link: encodeURI((window.location.href).split('.cn')[0])+'.cn', // 分享链接
            imgUrl: 'https://unionfit-img.oss-cn-beijing.aliyuncs.com/fit_logo.jpg', // 分享图标
            success(res) {
              console.log('斐燃生活分享')
              // alert('wx.updateTimelineShareData')
              console.log(res)
            },
            fail(){
              // alert('fail wx.updateTimelineShareData')
            }
          });
        } else {
          wx.onMenuShareAppMessage({
            title: '斐燃生活', // 分享标题
            desc: '全国高端酒店会员制专享平台，提供健身、瑜伽等服务', //分享描述
            link: encodeURI((window.location.href).split('.cn')[0])+'.cn', // 分享链接
            imgUrl: 'https://unionfit-img.oss-cn-beijing.aliyuncs.com/fit_logo.jpg', // 分享图标
            success(res) {
              console.log('斐燃生活分享')
              // alert('wx.onMenuShareAppMessage')
              console.log(res)
            },
            fail(){
              // alert('fail wx.onMenuShareAppMessage')
            }
          });
          wx.onMenuShareTimeline({
            title: '斐燃生活', // 分享标题
            link: encodeURI((window.location.href).split('.cn')[0])+'.cn', // 分享链接
            imgUrl: 'https://unionfit-img.oss-cn-beijing.aliyuncs.com/fit_logo.jpg', // 分享图标
            success(res) {
              console.log('斐燃生活分享')
              // alert('wx.onMenuShareTimeline')
              console.log(res)
            },
            fail(){
              // alert('fail wx.onMenuShareTimeline')
            }
          });
        }
      },
      /**
       * 2.2版本方法
       */
      // 获取我的会员卡
      FLGetUserCard(){
        var $this=this
        // $this.$loading('正在加载~')
        if(localStorage.getItem("token")){
          // console.log($this.$store.state.array_mycard)
          if($this.$store.state.array_mycard.length==0){
            let param = {
              token: localStorage.getItem("token"),
            }
            var qs = require('qs');
            let url = this.api.userApi.flUserCardsList
            this.axios.post(url, qs.stringify(param), )
            .then((result) => {
              // console.log(result)
              if (result.code == 0 && result.data && result.data) {
                $this.mycardList=result.data
                $this.$store.commit('updataMycard',result.data)
              } else {
                // $this.$toast(result.msg)
                $this.mycardList=[]
                $this.$store.commit('updataMycard',[])
              }
            }).catch((error) => {
              console.warn(error)
            })
          }else{
            // console.log($this.$store.state.array_mycard)
            $this.mycardList=$this.$store.state.array_mycard
          }
        }else{
          $this.mycardList=[]
        }
      },
      // 获取用户信息
      FLGetUserInfo(){
        // fl_userinfo
        var $this = this
        if(localStorage.getItem("token")){
          // console.log($this.$store.state.object_userinfo)
          // this.$loading('加载中~');
          if($this.$store.state.object_userinfo==null){
            let param = {
              token: localStorage.getItem("token")
            }
            var qs = require('qs');
            let url = this.api.userApi.getInfo
            this.axios.post(url, qs.stringify(param), )
             .then((result) => {
               // console.log(result)
               if (result.data) {
                 // result.data.user.name=''
                 $this.$store.commit('updataMyInfo',result.data.user)
                 $this.fl_userinfo=result.data.user
               } else {
                 $this.$toast(result.msg)
                 $this.fl_userinfo=null
               }
             }).catch((error) => {
               console.warn(error)
               $this.fl_userinfo=null
             })
          }else{
            // console.log(1)
            $this.fl_userinfo=$this.$store.state.object_userinfo
          }

        }else{
          $this.fl_userinfo=null
        }
      },
      // 获取可预约日期
      FLGetSevenDate(){
        // console.log('获取日期')
        var curDay = new Date();
        this.reserves_date=[]
        let week = ['周日', '周一', '周二', '周三', '周四', '周五', '周六'];
        if(curDay.getHours()<17){
          for (var i = 0; i < 8; i++) {
            var newdate = curDay.getTime()+24*60*60*1000*i
            var new_date_year=new Date(newdate).getFullYear()
            var new_date_month=new Date(newdate).getMonth()+1
            if(new_date_month<10){
              new_date_month='0'+new_date_month
            }
            var new_date_date=new Date(newdate).getDate()
            if(new_date_date<10){
              new_date_date='0'+new_date_date
            }
            var new_date_day=new Date(newdate).getDay()
            var obj={
              date_complete:new_date_year+'-'+new_date_month+'-'+new_date_date,
              date_simple:new_date_month+'.'+new_date_date,
              date_short:new_date_month+'-'+new_date_date,
              date_week:week[new_date_day]
            }
            if(i==0){
              obj.date_week='今天'
            }
            if(i==1){
              obj.date_week='明天'
            }
            this.reserves_date.push(obj)
          }
        }else{
          for (var i = 1; i <= 7; i++) {
            var newdate = curDay.getTime()+24*60*60*1000*i
            var new_date_year=new Date(newdate).getFullYear()
            var new_date_month=new Date(newdate).getMonth()+1
            var new_date_date=new Date(newdate).getDate()
            var new_date_day=new Date(newdate).getDay()
            if(new_date_month<10){
              new_date_month='0'+new_date_month
            }
            if(new_date_date<10){
              new_date_date='0'+new_date_date
            }
            var obj={
              date_complete:new_date_year+'-'+new_date_month+'-'+new_date_date,
              date_simple:new_date_month+'.'+new_date_date,
              date_short:new_date_month+'-'+new_date_date,
              date_week:week[new_date_day]
            }
            if(i==1){
              obj.date_week='明天'
            }
            this.reserves_date.push(obj)
          }
        }
        this.FLGetRegion()
      },
      // 获取城市列表
      FLGetRegion(){
        var $this = this
        // console.log($this.$store.state.array_cityList)
        if($this.$store.state.array_cityList_stadium.length==0){
          console.log('1')
          let param = {  }
          var qs = require('qs');
          let url = this.api.userApi.getCity
          this.axios.post(url, qs.stringify(param), )
          .then((result) => {
            if (result.data) {
              console.log(result)
              $this.$store.commit('updataCityListST',result.data.city)
              $this.city_list=result.data.city
              // $this.$store.commit('updateCityList',result.data.city)//设置
              // console.log($this.$store.state.fl_cityList)//取值
              // console.log(this.$store.state.list_stadiums)
              // fl_cityList
              if(localStorage.getItem('city')){
                $this.city=localStorage.getItem('city')
              }else{
                $this.city=result.data.city[0].name
              }
              $this.FLLoadStadiumList()
            } else {
              $this.$toast(result.msg)
              $this.city='上海'
              $this.FLLoadStadiumList()
            }
          }).catch((error) => {
            console.warn(error)
            $this.city='上海'
            $this.FLLoadStadiumList()
          })
        }else{
          console.log('2')
          var current=$this.$store.state.array_cityList_stadium
          $this.city_list=current
          if(localStorage.getItem('city')){
            $this.city=localStorage.getItem('city')
          }else{
            $this.city=current[0].name
          }
          $this.FLLoadStadiumList()
        }

      },
      // 显示当前条件下的酒店列表
      FLLoadStadiumList(){
        this.loaded=false
        var type=parseInt(this.radio,10)+1
        var $this = this
        // console.log(this.order_date_index)
        let param = {
          city:$this.city,
          type:type,
          date:this.reserves_date[this.order_date_index].date_complete
        }
        var qs = require('qs');
        let url = this.api.userApi.flStadiumLists
        this.axios.post(url, qs.stringify(param), )
        .then((result) => {
          // console.log(result)
          if (result.code==0) {
            if(result.data.stadiums.length>0){
              var curPosition=localStorage.getItem('curPosition')
              for (var i = 0; i < result.data.stadiums.length; i++) {
                if(curPosition){
                  result.data.stadiums[i].distance=distance((JSON.parse(curPosition)).latitude,(JSON.parse(curPosition)).longitude,result.data.stadiums[i].latitude,result.data.stadiums[i].longitude)
                  result.data.stadiums[i].distancenum=distancenum((JSON.parse(curPosition)).latitude,(JSON.parse(curPosition)).longitude,result.data.stadiums[i].latitude,result.data.stadiums[i].longitude)
                }else{
                  result.data.stadiums[i].distance=-1
                  result.data.stadiums[i].distancenum=-1
                }
              }
            }
            // for (var i = 0; i < result.data.stadiums.length; i++) {
            //   result.data.stadiums[i].origin_price=3500
            // }
            $this.fl_stadium_list=result.data.stadiums
            setTimeout(function(){
              $this.loaded=true
            },0)
          } else {
            $this.fl_stadium_list=[]
            $this.loaded=true
          }
        }).catch((error) => {
          console.warn(error)
          $this.fl_stadium_list=[]
          $this.loaded=true
        })
      },
      // 选择预约日期
      FLSelectDate(date){
        // console.log(date)
        // this.FLSelectDate(date.item,date.index)
        if(this.order_date_index!=date.index){
          this.order_date_index=date.index
          this.FLLoadStadiumList()
        }
      },
      // 选择运动类型
      FLSelectRadiuo(item){
        if(this.radio!=item){
          this.radio=item
          this.FLLoadStadiumList()
          if(this.radio=='0'||this.radio==0){
            document.title = '沸健身——畅享五星级奢华酒店游泳/健身';
          }else{
            document.title = '翡瑜伽——畅享五星级奢华酒店瑜伽';
          }
        }
      },
      // 切换城市面板显示和隐藏
      FLSelectCity(){
        this.cityPanelStatus=!this.cityPanelStatus
      },
      // 上划关闭城市面板
      FLSwipertop(){
        this.FLSelectCity()
      },
      // 切换城市
      FLSelectCityItem(item,index){
        // console.log(this.$store.state.fl_cityList)//取值
        // console.log(this.city_list)
        this.city=item.name
        localStorage.setItem('city',item.name)
        this.FLSelectCity()
        this.FLLoadStadiumList()
      },
      // 前往详情页
      FLDetail(item,index){
        // console.log('详情')
        // console.log(item)
        var $this=this
        if(this.radio=='1'){
          // sessionStorage.setItem('fullpage_date_mode',JSON.stringify(param))
          if(sessionStorage.getItem('fullpage_date_mode')){
            sessionStorage.removeItem('fullpage_date_mode')
          }
          sessionStorage.setItem('fullpage_filter_yoga','yes')
          setTimeout(function(){
            $this.$router.push({
              name:'resdetail',
              params:{
                stadium_id:item.stadium_id
              }
            })
          },300)
        }else{
          var param={
            // reserves_status:true,
            date_complete:this.reserves_date[this.order_date_index].date_complete,
            date_short:this.reserves_date[this.order_date_index].date_short,
            date_simple:this.reserves_date[this.order_date_index].date_simple,
            date_week:this.reserves_date[this.order_date_index].date_week,
            // stadium_list_config:this.stadium_list_config
          }
          sessionStorage.setItem('fullpage_date_mode',JSON.stringify(param))
          setTimeout(function(){
            $this.$router.push({
              name:'resdetail',
              params:{
                stadium_id:item.stadium_id
              }
            })
          },300)
        }
      },
      // 快速预约之前判断1
      FLCreate(item,index){
        var $this=this
        // console.log('健身快速预约')
        // console.log(item)

        if(!localStorage.getItem("token")){
          // 未登录状态，直接登录
          this.$router.push({
            name: "login",
          });
          return
        }
        // console.log(getStValStatus($this.fl_userinfo.name))
        // console.log(getStValStatus($this.fl_userinfo.name).code==1)
        if($this.fl_userinfo==null ||getStValStatus($this.fl_userinfo.name).code==0){
          // 未实名，先实名
          $this.$router.push({
            name:'realname',
            params:{
              initialswipe:'list'
            }
          })
          return
        }
        this.$loading('加载预约信息')
        // 用户是否在黑名单中
        var param={
          token: localStorage.getItem("token"),
          stadium_id:item.stadium_id
        }
        var qs = require('qs');
        let url = this.api.userApi.getBlacklist
        this.axios.post(url,qs.stringify(param),)
        .then((res) => {
          // console.log(res)
          if (res.data) {
            if(res.data.is_in_blacklist==0){
              $this.$loading.close()
              $this.FLCreateRou(item,index)//快速预约
            }else{
              $this.$loading.close()
              $this.$toast('抱歉，您暂时无法使用该健身礼遇，请详询客服服务热线。')
            }
          } else {
            $this.$loading.close()
            $this.$toast(res.msg)
          }
        }).catch((error) => {
          console.warn(error)
          $this.$loading.close()
          $this.$toast(res.msg);
        })
      },
      // 快速预约之前判断2
      FLCreateRou(item,index){
        var $this=this
        // console.log(item)
        if(item.is_business==0 && getStValStatus(item.business_tip).stat==true){

          this.$dialog.alert({
            title: '温馨提示',
            message: item.business_tip,
            confirmButtonColor: '#544590'
          }).then(() => {

          });
          return
        }
        if(getStValStatus(item.business_tip).stat==true){
          this.$dialog.alert({
            title: '温馨提示',
            message: item.business_tip,
            confirmButtonColor: '#544590'
          }).then(() => {

          });
        }
        // var sd_area_id=''
        this.$loading('加载订单信息')
        let param = {
          token: localStorage.getItem("token"),
          stadium_id: item.stadium_id,
        }
        var qs = require('qs');
        let url = this.api.userApi.getStadiumDetailVersionTwo
        this.axios.post(url, qs.stringify(param), )
        .then((result) => {
          // console.log(result)
          if (result.data) {
            // sd_area_id=result.data.fit_service_id
            $this.FLCreateRouter(item,index,result.data.fit_service_id)
          }else{
            $this.$loading.close()
            $this.$toast(res.msg);
          }
        }).catch((error) => {
          console.warn(error)
          $this.$loading.close()
        })


        // sessionStorage.setItem('sd_area_id',this.sd_area_id);//创建订单：场馆id,健身下单需要
        // sessionStorage.setItem('create_order_type','fit');//创建订单：类型
        // sessionStorage.setItem('stadium_current',JSON.stringify(this.stadium_current));//创建订单：当前场馆信息
        // sessionStorage.setItem('select_fit_date',JSON.stringify(this.select_fit_date));//创建订单：健身日期


        /**
         * 健身：
         *      是否黑名单、
         *      预约日期、
         *      场馆id：sd_area_id
         *      创建订单：类型
         *      创建订单：当前场馆信息
         *      创建订单：健身日期
         *      是否是斐燃会员
         * 瑜伽：
         *      瑜伽不能快速预约
         *
         */
      },
      FLCreateRouter(item,index,sd_area_id){
        var $this=this
        sessionStorage.setItem('sd_area_id',sd_area_id);//创建订单：场馆id,健身下单需要
        sessionStorage.setItem('create_order_type','fit');//创建订单：类型
        sessionStorage.setItem('stadium_current',JSON.stringify(item));//创建订单：当前场馆信息
        // sessionStorage.setItem('select_fit_date',JSON.stringify(this.select_fit_date));//创建订单：健身日期

        // console.log(this.reserves_date[this.order_date_index])
        // reserves_date:[],//可预约日期
        // order_date_index:0,//默认选中日期索引
        var date=this.reserves_date[this.order_date_index].date_complete
        let param = {
          token: localStorage.getItem("token"),
          stadium_id: item.stadium_id,
        }
        // console.log(date)
        var qs = require('qs');
        let url = this.api.userApi.getFityogastocks
        this.axios.post(url, qs.stringify(param), )
        .then((result) => {
          // console.log(result)
          if (result.data) {
            for (var i = 0; i < result.data.fit.length; i++) {
              if(result.data.fit[i].date==date){
                sessionStorage.setItem('select_fit_date',JSON.stringify(result.data.fit[i]));
                // console.log(result.data.fit[i].date)
                $this.$loading.close()
                if($this.mycardList.length>0){
                  $this.$router.push({
                    name:'createorder',
                  })
                }else{
                  $this.$router.push({
                    name:'createordernocard',
                  })
                }
                break;
              }
            }
          }else{
            $this.$loading.close()
          }
        }).catch((error) => {
          console.warn(error)
        })
      },
    }
  }
</script>

<style lang="less" scoped="scoped">
  @vm_base: 1/750*100vw;
  .fl_list_head{
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 99;
    background: #FFFFFF;
    box-shadow: 0px 10*@vm_base 20*@vm_base 0px #EEEEEE;
    .fl_list_head_type{
      width: 100%;
      padding: 0 32*@vm_base;
      font-size: 28*@vm_base;
      font-weight: 500;
      color: #333333;
      line-height: 1;
      .fl_list_head_type_city{
        padding: 30*@vm_base 0;
        background-image: url(../../assets/images/FLVersion/fl_posi.png);
        background-size: 22*@vm_base 28*@vm_base;
        background-repeat: no-repeat;
        padding-left: 34*@vm_base;
        background-position: left center;
        float: left;
      }
      .fl_list_head_type_type{
        float: right;
        padding: 30*@vm_base 0 30*@vm_base 36*@vm_base;
        margin-left: 48*@vm_base;
        background-image: url(../../assets/images/base/choose_sport_nonew.png);
        background-size: 24*@vm_base 24*@vm_base;
        background-position: left center;
        background-repeat: no-repeat;
        color: #333333;
        font-weight: 400;
        position: relative;
        .fl_list_head_type_type_la{
          width: calc(100% - 36*@vm_base);
          position: absolute;
          bottom: 0;
          right: 0;
          z-index: -1;
          margin-bottom: 30*@vm_base;
          height: 10*@vm_base;
          background: rgba(241, 205, 135, 0.5);
        }
      }
      .fl_list_head_type_typeS{
        background-image: url(../../assets/images/base/choose_sport_yesnew.png);
        font-weight: 700;
      }
    }
    .fl_list_head_date{
      padding: 10*@vm_base 0 30*@vm_base 32*@vm_base;
      width: 100%;
      overflow: hidden;
      overflow-x: auto;
      &::-webkit-scrollbar{width:0px;height: 0;}
      // .fl_list_head_date_block{
      //   width: calc(140*@vm_base * 7 + 16*@vm_base);
      //   .fl_list_head_date_item{
      //     width: 120*@vm_base;
      //     height: 120*@vm_base;
      //     background: #FFFFFF;
      //     border-radius: 12*@vm_base;
      //     border: 1*@vm_base solid #DDDDDD;
      //     float: left;
      //     margin-right: 20*@vm_base;
      //     color: #444054;
      //     .fl_list_head_date_item_title1{
      //       width: 100%;
      //       font-size: 32*@vm_base;
      //       font-weight: 500;
      //       line-height: 1;
      //       text-align: center;
      //       margin-top: 26*@vm_base;
      //     }
      //     .fl_list_head_date_item_title2{
      //       width: 100%;
      //       margin-top: 12*@vm_base;
      //       font-size: 24*@vm_base;
      //       font-weight: 400;
      //       line-height: 1;
      //       text-align: center;
      //     }
      //   }
      //   .fl_list_head_date_itemS{
      //     background: #444054;
      //     color: #FFFFFF;
      //   }
      // }
      // .fl_list_head_date_blockE{
      //   width: calc(140*@vm_base * 8 + 16*@vm_base);
      // }
    }
  }
  .fl_seat_fit{
    height: 248*@vm_base;
  }
  .fl_seat_yoga{
    height: 88*@vm_base;
  }
  // // 列表
  // .fl_list_body{
  //   width: calc(100% - 0*@vm_base);
  //   margin-top: 40*@vm_base;
  //   padding: 0*@vm_base 32*@vm_base 0 32*@vm_base;
  //   height: calc(100vh - 40*@vm_base - 248*@vm_base);
  //   overflow: hidden;
  //   overflow-y: auto;
  //   .fl_list_body_item{
  //     display: flex;
  //     justify-content: center;
  //     align-items: center;
  //     margin-bottom: 120*@vm_base;
  //     position: relative;
  //     // border-radius: 12*@vm_base;
  //     // overflow: hidden;
  //     .fl_list_body_item_imgMM{
  //       width: 100%;
  //       overflow: hidden;border-radius: 12*@vm_base;
  //     }
  //     .fl_list_body_item_img{
  //       height: 428*@vm_base;
  //     }
  //     .fllpr_panel{
  //       position: absolute;
  //       bottom: 0;
  //       left: 0;
  //       z-index: 1;
  //       width: calc(100% - 60*@vm_base);
  //       margin-left: 30*@vm_base;
  //       margin-bottom: -65*@vm_base;
  //       background: #FFFFFF;
  //       box-shadow: 0px 2*@vm_base 10*@vm_base 0px rgba(0, 0, 0, 0.1);
  //       border-radius: 12*@vm_base;
  //       padding: 28*@vm_base 30*@vm_base;

  //       .fllpr_panel_txt{
  //         width: 100%;
  //         font-size: 24*@vm_base;
  //         font-weight: 500;
  //         color: #666666;
  //         .fllpr_panel_origin{
  //           font-size: 32*@vm_base;
  //         }
  //         .fllpr_panel_viper{
  //           color: #C9914B;
  //         }
  //         .fllpr_panel_vipprice{
  //           font-size: 32*@vm_base;
  //           color: #C9914B;
  //         }
  //       }
  //       .fllpr_panel_distance{
  //         width: 100%;
  //         font-size: 24*@vm_base;
  //         font-weight: 400;
  //         color: #999999;
  //         padding-left: 23*@vm_base;
  //         background-image: url(../../assets/images/FLVersion/nav_location_defaul.png);
  //         background-size: 15*@vm_base;
  //         background-repeat: no-repeat;
  //         background-position: left center;
  //         margin-top: 5*@vm_base;
  //       }
  //     }
  //     .fllpr_quickcreate{
  //       position: absolute;
  //       bottom: 0;
  //       right: 0;
  //       z-index: 2;
  //       width: 160*@vm_base;
  //       height: 64*@vm_base;
  //       border-radius: 32*@vm_base;
  //       border: 1px solid #444054;
  //       background: #FFFFFF;
  //       font-size: 24*@vm_base;
  //       font-weight: 500;
  //       color: #0A0A0A;
  //       margin-bottom: -30*@vm_base;
  //       margin-right: 60*@vm_base;
  //     }
  //     .fllpr_quickcreaten{
  //       position: absolute;
  //       bottom: 0;
  //       right: 0;
  //       z-index: 2;
  //       width: 160*@vm_base;
  //       height: 64*@vm_base;
  //       border-radius: 32*@vm_base;
  //       border: 1px solid #999999;
  //       background: #FFFFFF;
  //       font-size: 24*@vm_base;
  //       font-weight: 500;
  //       color: #999999;
  //       margin-bottom: -30*@vm_base;
  //       margin-right: 60*@vm_base;
  //     }
  //     .fllpr_black{
  //       position: absolute;
  //       bottom: 0;
  //       right: 0;
  //       z-index: 2;
  //       width: 220*@vm_base;
  //       height: 60*@vm_base;
  //       line-height: 60*@vm_base;
  //       background: linear-gradient(90deg, rgba(242, 206, 136, 0) 0%, #F2CE88 100%);

  //       text-align: center;
  //       font-size: 24*@vm_base;
  //       font-weight: 500;
  //       color: #000000;
  //       margin-bottom: -28*@vm_base;
  //       margin-right: 30*@vm_base;
  //     }
  //     .fl_list_body_item_distance{
  //       position: absolute;
  //       top: 0;
  //       left: 0;
  //       background: rgba(0, 0, 0, 0.5);
  //       border-radius: 40*@vm_base;

  //       font-size: 20*@vm_base;
  //       font-weight: 500;
  //       color: #FFFFFF;
  //       line-height: 1;
  //       padding: 20*@vm_base 32*@vm_base;
  //       margin-top: 20*@vm_base;
  //       margin-left: 20*@vm_base;
  //       label{
  //         background-image: url(../../assets/images/base/location_hotelphoto.png);
  //         background-size: 12*@vm_base 16*@vm_base;
  //         background-repeat: no-repeat;
  //         background-position: left center;
  //         padding: 0 12*@vm_base 0 24*@vm_base;
  //       }
  //     }
  //     .fl_list_body_item_quick{
  //       position: absolute;
  //       bottom: 0;
  //       right: 0;
  //       background: rgba(0, 0, 0, 0.4);
  //       border-radius: 32*@vm_base;
  //       margin-bottom: 20*@vm_base;
  //       margin-right: 20*@vm_base;
  //       color: #FFFFFF;
  //       font-size: 24*@vm_base;
  //       font-weight: 500;
  //       // line-height: 1;
  //       padding: 15*@vm_base 48*@vm_base 15*@vm_base 36*@vm_base;
  //       background-image: url(../../assets/images/base/orderArrow_white.png);
  //       background-size: 16*@vm_base 24*@vm_base;
  //       background-repeat: no-repeat;
  //       background-position: 90% center;
  //       // border: 1px solid red;
  //     }
  //     .fl_list_body_item_blackVip{
  //       width: 160*@vm_base;
  //       position: absolute;
  //       right: 0;
  //       top: 0;
  //       margin: 20*@vm_base 20*@vm_base 0 0;
  //     }
  //     .fl_list_body_item_full{
  //       width: 80*@vm_base;
  //       position: absolute;
  //       right: 0;
  //       top: 0;
  //       margin: 0 20*@vm_base 0 0;
  //     }
  //   }
  // }
  // .fl_list_body_yoga{
  //   height: calc(100vh - 40*@vm_base - 88*@vm_base);
  // }
  // // 无酒店
  // .stadium_noHotel{
  //   width: 100%;
  //   background: #FFFFFF;
  //   border-radius: 12*@vm_base;
  //   padding: 14*@vm_base 60*@vm_base 60*@vm_base 60*@vm_base;
  //   .stadium_noHotel_img{
  //     width: 276*@vm_base;
  //     margin: 0 auto;
  //   }
  //   .stadium_noHotel_title{
  //     width: 100%;
  //     font-size: 28*@vm_base;
  //     font-weight: 500;
  //     color: #333333;
  //     margin-bottom: 15*@vm_base;
  //     text-align: center;
  //   }
  //   .stadium_noHotel_cont{
  //     width: 100%;
  //     font-size: 24*@vm_base;
  //     font-weight: 500;
  //     color: #B4B3BB;
  //     text-align: center;
  //   }
  // }

  // // 城市面板
  // .nhl_city{
  //   position: fixed;
  //   top: 0;
  //   left: 0;
  //   width: 100%;
  //   height: 0;
  //   margin-top: 90*@vm_base;
  //   background: #FFFFFF;
  //   z-index:100;
  //   overflow: hidden;
  //   transition:all .5s ease-in;
  //   .city_title{
  //     width: 100%;
  //     padding: 24*@vm_base 0 24*@vm_base 32*@vm_base;
  //     background: #FBFBFB;
  //     font-size: 24*@vm_base;
  //     font-weight: 500;
  //     color: #8F8C98;
  //   }
  //   .city_currentSelect{
  //     width: 100%;
  //     padding: 32*@vm_base 0 32*@vm_base 44*@vm_base;
  //     background: #FFFFFF;
  //     .item{
  //       width: 140*@vm_base;
  //       text-align: center;
  //       background: #444054;
  //       border-radius: 6*@vm_base;

  //       font-size: 32*@vm_base;
  //       font-weight: 500;
  //       color: #FFFFFF;
  //       padding: 14*@vm_base 0;
  //     }
  //   }
  //   .city_stitle{
  //     width: 100%;
  //     padding: 24*@vm_base 0 24*@vm_base 32*@vm_base;
  //     background: #F5F5F5;
  //     font-size: 24*@vm_base;
  //     font-weight: 500;
  //     color: #8F8C98;
  //   }
  //   .city_item{
  //     width: 100%;
  //     height: 650*@vm_base;
  //     //calc(100vh - 574*@vm_base);
  //     overflow-y: auto;
  //     padding: 40*@vm_base 10*@vm_base 0 10*@vm_base;
  //     background: #FFFFFF;
  //     .item{
  //       width: 140*@vm_base;
  //       text-align: center;
  //       padding: 14*@vm_base 0;
  //       margin-left: 34*@vm_base;
  //       border-radius: 6*@vm_base;
  //       border: 1*@vm_base solid #979797;
  //       float: left;
  //       margin-bottom: 40*@vm_base;
  //       font-size: 32*@vm_base;
  //       font-weight: 500;
  //       color: #444054;
  //     }
  //   }
  //   .city_gif{
  //     width: 100%;
  //     height:calc(100vh - 1050*@vm_base);
  //     // padding-top: 80*@vm_base;
  //     position: relative;
  //     img{
  //       position: absolute;
  //       bottom: 0;
  //       left: 0;
  //       width: 90%;
  //       margin-left: 5%;
  //     }
  //   }
  // }
  // .nhl_city.active{
  //   height: calc(100vh - 90*@vm_base);
  //   transition:all .5s ease-in;
  // }
</style>



// WEBPACK FOOTER //
// src/components/reserve/reserve.vue